/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import SVG from "react-inlinesvg";
import { Spinner } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { toAbsoluteUrl } from "../../../_helpers";
import { gql, useQuery } from '@apollo/client';
import {Link} from "react-router-dom";

export function BrandWidget({ type, title, subtitle, tooltip, className, query, whitelist, client }) {



  if (!query) {
    return (
      <>
        <div className={`card card-custom ${className}`}>
          <div className="card-header border-0">
          </div>
          <div className="card-body pt-0">
            <div className="d-flex align-items-center flex-wrap mb-5">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
    <div className={`card card-dashboard ${className}`} style={{height: "350px"}}>
        {/* Header */}
        <div className="card-header border-0" style={{display: "block", marginTop: "18px"}}>
          <OverlayTrigger
            key="bottom"
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-bottom`}>
                {tooltip}
              </Tooltip>
            }
          ><>
            <h3 style={{ cursor: "pointer" }} className="font-weight-bolder text-dark">{title}</h3>
            </>
          </OverlayTrigger>
          <p style={{ cursor: "pointer" }} className="text-dark-25">{tooltip}</p>
        </div>
        {/* Body */}
        <div className="card-body pt-0">
          {query[type].map((data, index) =>
            <div key={index} className="d-flex align-items-center flex-wrap mb-5">
              <div className="d-flex flex-column flex-grow-1">
              {data.product_name}
              </div>
              <span style={{pointerEvents: "none"}} className="btn btn-sm btn-light font-weight-bolder my-lg-0 my-2 py-1 text-dark-50">
              {data.count}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

